export default [
	{
		path: 'distribution/map',
		name: 'm_distribution_map',
		meta: {
			title: '人员与客户分布'
		},
		component: () => import('@/pages/kanban/distribution_map.vue')
	},
	{
		path: 'statistics/performance',
		name: 'm_performance_statistics',
		meta: {
			title: '绩效统计'
		},
		component: () => import('@/pages/kanban/engineer_performance_list.vue')
	},
	{
		path: 'statistics/aftersale/cost/analysis',
		name: 'm_aftersale_cost_analysis',
		meta: {
			title: '工单成本统计'
		},
		component: () => import('@/pages/kanban/aftersale_cost_analysis.vue')
	},
	{
		path: 'statistics/attendance/report',
		name: 'm_attendance_analysis',
		meta: {
			title: '考勤统计'
		},
		component: () => import('@/pages/kanban/attendance_analysis.vue')
	},
];